const initialState = {
  tables: [],
  ui: { loading: true }
};

export default initialState;